// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var navContents = "NavContents-module--nav-contents--pDLaG";
export var open = "NavContents-module--open--2pOpR";